/* ==========================================================================
   tu-asp-multi.js
   Erweiterung fuer tu-adv-sales-page:
   1. Produkt-Waehler im Hero (Produkt -> Groesse), arbeitet mit den
      bestehenden Kacheln aus tu-adv-sales-page.js zusammen.
   2. Countdown (24-h-Evergreen mit Auto-Reset, festes Enddatum oder
      Tagesaktion bis Mitternacht deutscher Zeit).
   3. Varianten-Chips im Angebotsblock.
   4. Mengenwahl + Warenkorb per AJAX (Kunde bleibt auf der Seite, UpCart oeffnet).
   Alles ist auf die Section gescoped (data-tu-asp-root).
   ========================================================================== */
(function () {
  'use strict';

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  /* ------------------------------------------------ 1. Produkt-Waehler -- */
  function initProducts(root) {
    var prods = root.querySelectorAll('[data-tu-prod]');
    if (!prods.length) return;

    var groups = root.querySelectorAll('[data-tu-group]');
    var packs = root.querySelectorAll('[data-tu-pack]');
    var tags = root.querySelectorAll('[data-tu-pricetag-for]');

    function show(id, selectTier) {
      each(prods, function (p) {
        p.setAttribute('aria-pressed', p.getAttribute('data-tu-prod') === id ? 'true' : 'false');
      });
      each(groups, function (g) {
        g.hidden = g.getAttribute('data-tu-group') !== id;
      });
      each(packs, function (img) {
        img.hidden = img.getAttribute('data-tu-pack') !== id;
      });
      each(tags, function (t) {
        t.hidden = t.getAttribute('data-tu-pricetag-for') !== id;
      });

      if (!selectTier) return;
      var group = root.querySelector('[data-tu-group="' + id + '"]');
      if (!group) return;
      var tier =
        group.querySelector('[data-tu-tier][data-tu-last="true"]') ||
        group.querySelector('[data-tu-tier][data-tu-default="true"]') ||
        group.querySelector('[data-tu-tier]');
      /* Klick laeuft durch die Logik aus tu-adv-sales-page.js (CTA, Preis, Variante) */
      if (tier) tier.click();
    }

    each(prods, function (p) {
      p.addEventListener('click', function () {
        show(p.getAttribute('data-tu-prod'), true);
      });
    });

    /* Zuletzt gewaehlte Groesse pro Produkt merken, Variantenbild tauschen */
    each(groups, function (g) {
      var gid = g.getAttribute('data-tu-group');
      var tiers = g.querySelectorAll('[data-tu-tier]');
      each(tiers, function (t) {
        t.addEventListener('click', function () {
          each(tiers, function (o) {
            o.setAttribute('data-tu-last', o === t ? 'true' : 'false');
          });
          var src = t.getAttribute('data-tu-pack-src');
          var img = root.querySelector('[data-tu-pack="' + gid + '"]');
          if (src && img && img.getAttribute('src') !== src) {
            img.removeAttribute('srcset');
            img.setAttribute('src', src);
          }
        });
      });
    });

    var start = root.querySelector('[data-tu-prod][aria-pressed="true"]') || prods[0];
    show(start.getAttribute('data-tu-prod'), false);
  }

  /* ------------------------------------------------------- 2. Countdown -- */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function readStore(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(key, val) {
    try {
      window.localStorage.setItem(key, val);
    } catch (e) {
      /* privates Fenster o. ae.: Timer laeuft trotzdem, nur ohne Gedaechtnis */
    }
  }

  function initTimer(root) {
    var mode = root.getAttribute('data-tu-timer-mode') || 'off';
    if (mode === 'off') return;

    var slots = root.querySelectorAll('[data-tu-timer]');
    var mobSlots = root.querySelectorAll('[data-tu-mob-timer]');
    if (!slots.length && !mobSlots.length) return;

    var hours = parseFloat(root.getAttribute('data-tu-timer-hours')) || 24;
    var span = hours * 3600000;
    var key = 'tu-asp-timer-' + (root.getAttribute('data-tu-timer-key') || root.id);
    var end = 0;

    function resetEvergreen() {
      end = Date.now() + span;
      writeStore(key, String(end));
    }

    /* Naechste Mitternacht in Deutschland (Europe/Berlin), egal in welcher
       Zeitzone das Geraet steht. Beruecksichtigt auch die Zeitumstellung. */
    function berlinParts(t) {
      var val = { year: 0, month: 1, day: 1, hour: 0, minute: 0, second: 0 };
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date(t));
      each(parts, function (part) {
        if (part.type in val) val[part.type] = parseInt(part.value, 10) || 0;
      });
      val.hour = val.hour % 24;
      return val;
    }

    function nextMidnight() {
      var now = Date.now();
      try {
        var p = berlinParts(now);
        var guess = Date.UTC(p.year, p.month - 1, p.day + 1, 0, 0, 0);
        var q = berlinParts(guess);
        var offset = Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second) - guess;
        return guess - offset;
      } catch (e) {
        /* sehr alter Browser ohne Zeitzonen-Unterstuetzung: Geraetezeit */
        var d = new Date(now);
        d.setHours(24, 0, 0, 0);
        return d.getTime();
      }
    }

    if (mode === 'evergreen') {
      end = parseInt(readStore(key), 10) || 0;
      if (!end || end <= Date.now() || end - Date.now() > span) resetEvergreen();
    } else if (mode === 'daily') {
      end = nextMidnight();
    } else {
      end = new Date(root.getAttribute('data-tu-timer-end') || '').getTime();
      if (isNaN(end)) return;
    }

    var hideExpired = root.getAttribute('data-tu-timer-hide') === 'true';

    function render() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (mode === 'evergreen') {
          resetEvergreen();
          diff = end - Date.now();
        } else if (mode === 'daily') {
          end = nextMidnight();
          diff = end - Date.now();
        } else {
          diff = 0;
        }
      }
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      var hh = pad(d * 24 + h);

      each(slots, function (el) {
        if (mode === 'date' && diff === 0 && hideExpired) {
          el.hidden = true;
          return;
        }
        el.hidden = false;
        var u = el.querySelectorAll('[data-tu-t]');
        each(u, function (x) {
          var k = x.getAttribute('data-tu-t');
          x.textContent = k === 'h' ? hh : k === 'm' ? pad(m) : pad(s);
        });
      });
      each(mobSlots, function (el) {
        var label = el.getAttribute('data-tu-label') || '';
        el.textContent = (label ? label + ' ' : '') + hh + ':' + pad(m) + ':' + pad(s);
        el.hidden = mode === 'date' && diff === 0 && hideExpired;
      });
    }

    render();
    setInterval(render, 1000);
  }

  /* ----------------------------------------- 3. Angebotsblock: Chips -- */
  function initPackChips(root) {
    var cards = root.querySelectorAll('[data-tu-pack-card]');
    each(cards, function (card) {
      var chips = card.querySelectorAll('[data-tu-chip]');
      if (!chips.length) return;
      var prices = card.querySelectorAll('[data-tu-pv]');
      var imgs = card.querySelectorAll('[data-tu-pimg]');
      var input = card.querySelector('input[name="id"]');
      var btn = card.querySelector('[data-tu-pack-btn]');
      var btnLabel = btn ? btn.getAttribute('data-tu-label') || btn.textContent : '';
      var soldOut = btn ? btn.getAttribute('data-tu-soldout') || 'Ausverkauft' : '';
      var hasImg = false;
      each(imgs, function (img) {
        if (img.getAttribute('data-tu-pimg') !== 'default') hasImg = true;
      });

      function select(chip) {
        if (chip.getAttribute('aria-disabled') === 'true') return;
        var id = chip.getAttribute('data-tu-chip');
        each(chips, function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        each(prices, function (p) {
          p.hidden = p.getAttribute('data-tu-pv') !== id;
        });
        if (hasImg) {
          var match = card.querySelector('[data-tu-pimg="' + id + '"]');
          each(imgs, function (img) {
            var k = img.getAttribute('data-tu-pimg');
            img.hidden = match ? k !== id : k !== 'default';
          });
        }
        if (input) input.value = id;
        if (btn) {
          var ok = chip.getAttribute('data-tu-available') !== 'false';
          btn.disabled = !ok;
          btn.textContent = ok ? btnLabel : soldOut;
        }
      }

      each(chips, function (c) {
        c.addEventListener('click', function () {
          select(c);
        });
      });
      var start = card.querySelector('[data-tu-chip][aria-pressed="true"]') || chips[0];
      select(start);
    });
  }


  /* ------------------------------------- 4. Menge + AJAX-Warenkorb -- */
  function initQty(root) {
    each(root.querySelectorAll('[data-tu-qty]'), function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      function set(n) {
        var max = parseInt(input.getAttribute('max'), 10) || 99;
        if (isNaN(n) || n < 1) n = 1;
        if (n > max) n = max;
        input.value = n;
      }
      var minus = box.querySelector('[data-tu-qty-minus]');
      var plus = box.querySelector('[data-tu-qty-plus]');
      if (minus) minus.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { set(parseInt(input.value, 10)); });
    });
  }

  /* UpCart oeffnen bzw. aktualisieren. Reihenfolge wie in tu-sale-page.js (dort im Einsatz) */
  function openCart(root) {
    var open = root.getAttribute('data-tu-open-cart') !== 'false';
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (!open) return;
      if (typeof window.openUpcart === 'function') {
        window.openUpcart();
        return;
      }
      document.dispatchEvent(new CustomEvent('upcart:open'));
      var toggle = document.querySelector('.upcart-toggle, [data-upcart-toggle], #upcart-toggle');
      if (toggle) {
        toggle.click();
        return;
      }
      var icon = document.querySelector('[data-cart-icon-bubble], [data-header-cart], #cart-icon-bubble, a[href="/cart"]');
      if (icon) icon.click();
    } catch (e) {
      /* Drawer ist Komfort; der Artikel liegt trotzdem im Warenkorb */
    }
  }

  function initAjaxCart(root) {
    var doneLabel = root.getAttribute('data-tu-added-label') || '✓ Im Warenkorb';
    var busyLabel = root.getAttribute('data-tu-busy-label') || 'Wird hinzugefügt …';

    each(root.querySelectorAll('form[data-tu-ajax]'), function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[type="submit"]');
        var idInput = form.querySelector('input[name="id"]');
        var qtyInput = form.querySelector('input[name="quantity"]');
        var id = idInput ? idInput.value : '';
        if (!id) return; /* ohne Variante normal absenden lassen */
        e.preventDefault();
        if (!btn || btn.getAttribute('data-tu-state') === 'busy') return;

        var label = btn.innerHTML;
        var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
        btn.setAttribute('data-tu-state', 'busy');
        btn.textContent = busyLabel;

        function reset(delay) {
          setTimeout(function () {
            btn.innerHTML = label;
            btn.removeAttribute('data-tu-state');
          }, delay);
        }

        var addUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Fehler');
              return data;
            });
          })
          .then(function () {
            btn.setAttribute('data-tu-state', 'done');
            btn.textContent = doneLabel;
            if (qtyInput) qtyInput.value = 1;
            openCart(root);
            reset(2200);
          })
          .catch(function (err) {
            btn.setAttribute('data-tu-state', 'error');
            btn.textContent = err && err.message && err.message.length < 60 ? err.message : 'Fehler – bitte nochmal';
            reset(3000);
          });
      });
    });
  }

  /* ------------------------------------------------------------ Start -- */
  function initSection(root) {
    if (!root || root.dataset.tuMultiInit === 'true') return;
    root.dataset.tuMultiInit = 'true';
    initProducts(root);
    initTimer(root);
    initPackChips(root);
    initQty(root);
    initAjaxCart(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-tu-asp-root]');
    each(roots, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var prod = event.target.closest ? event.target.closest('[data-tu-prod]') : null;
    if (prod) prod.click();
  });
})();